import * as THREE from "three";
import { EffectComposerPass } from "../examples/jsm/postprocessing/EffectComposerPass";

export class AlternativeMaterialPass extends EffectComposerPass {
  camera: THREE.Camera;
  scene: THREE.Scene | undefined;

  outputToScreen: boolean = false;

  private overrideMaterials = new WeakMap<THREE.Material, THREE.Material>();

  private alternativeMaterialBuffer: THREE.WebGLRenderTarget;

  constructor(scene: THREE.Scene | undefined, camera: THREE.Camera) {
    super();
    this.scene = scene;
    this.camera = camera;

    this.alternativeMaterialBuffer = new THREE.WebGLRenderTarget(256, 256, { colorSpace: THREE.NoColorSpace });
  }

  setSize(width: number, height: number): void {
    super.setSize(width, height);
    this.alternativeMaterialBuffer.setSize(width, height);
  }

  updateScene(): void {
    if (!this.scene) {
      return;
    }
    this.overrideMaterials = new WeakMap();
    this.scene.traverse((obj) => {
      if (obj instanceof THREE.Mesh && obj.material.userData.alternativeMaterial) {
        this.overrideMaterials.set(obj.material, obj.material.userData.alternativeMaterial);
      }
    });
  }

  render(renderer: THREE.WebGLRenderer, writeBuffer: THREE.WebGLRenderTarget | null): void {
    if (this.scene === undefined || this.camera === undefined) {
      return;
    }
    renderer.setRenderTarget(this.outputToScreen ? writeBuffer : this.alternativeMaterialBuffer);
    this.scene.overrideMaterial = this.overrideMaterials as any; // Using our three.js override materials patch
    renderer.setClearColor(0x000000, 0.0);
    renderer.clear();
    renderer.render(this.scene, this.camera);
    this.scene.overrideMaterial = null;
    renderer.setRenderTarget(null);
  }

  get alternativeMaterialTexture(): THREE.Texture {
    return this.alternativeMaterialBuffer.texture;
  }

  dispose(): void {
    this.alternativeMaterialBuffer.dispose();
  }
}
